import { render, staticRenderFns } from "./CreateEventDialog.vue?vue&type=template&id=95e64b04&scoped=true"
import script from "./CreateEventDialog.vue?vue&type=script&lang=js"
export * from "./CreateEventDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateEventDialog.vue?vue&type=style&index=0&id=95e64b04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e64b04",
  null
  
)

export default component.exports